class EditTestCaseController {
    constructor($window, $browser, toastr, TestCaseMedadataServiceApi, UserDetailsApi, Upload, TestCasesServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                suite: {},
                selectedTest: {
                    Id: 0,
                    TestCaseName: 'Not selected',
                    TestCaseInformation: ''
                },
                showUpdated: false,
                expiryRules: {},
            };
            this.data = {
                testCases: [],
                userDetails: {},
                testCaseMetadataList: {},
                testCaseMetadataUpdate: {},
                testCaseUpdateObj: {}
            };
            // Keep the unfilteered test cases here
            this.testCases = [];
            let params = this.resolve;
            this.state.suite = params.suite;
            let visibleExpirys = params.visibleExpirys;
            this.state.expiryRules = {
                showRed: visibleExpirys.indexOf('R') > -1,
                showAmber: visibleExpirys.indexOf('A') > -1,
                showGreen: visibleExpirys.indexOf('G') > -1,
                showUncategorized: visibleExpirys.indexOf('U') > -1
            };
            // Check if the suites current class is not to be displayed - if not then hide it.
            if ((this.state.suite.expiryClass === 'traffic-danger' &&
                !this.state.expiryRules.showRed) ||
                (this.state.suite.expiryClass === 'traffic-warning' &&
                    !this.state.expiryRules.showAmber) ||
                (this.state.suite.expiryClass === 'traffic-success' &&
                    !this.state.expiryRules.showGreen) ||
                (this.state.suite.expiryClass === 'traffic-off' &&
                    !this.state.expiryRules.showUncategorized)) {
                this.state.suite.expiryClass = '';
            }
            this.UserDetails.get().then((data) => {
                let userData = data;
                this.data.userDetails = userData;
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
        };
        this.save = (testInfo) => {
            // TODO : Why do we pass in this.data.testCaseMetadataUpdate.TestCase that is available in the vm already? Maybe re-work
            // the shape of the data in the call to updateTestCaseObj - seems to be duplication in the structure?
            // build up custom object prior to sending to API
            this.data.testCaseUpdateObj.TestCaseMetadataUpdate = this.data.testCaseMetadataUpdate;
            this.data.testCaseUpdateObj.TestCaseInfo = testInfo;
            this.data.testCaseUpdateObj.TestCaseInfo.TestCaseInfoChars =
                testInfo.TestCaseInfoChars;
            this.TestCasesServiceApi.updateTestCaseObject(this.data.testCaseUpdateObj).then((response) => {
                // update the testCases and the current this.data.testCases
                this.state.showUpdated = true;
            });
        };
        this.cancel = () => {
            this.dismiss();
        };
        // TODO: Create an ag-grid to hold the test case info
        /////////////////// File Upload Methods ///////////////////
        this.onUploaded = (response) => {
            let testCases = response.data;
            this.selectTest(testCases[0]);
            this.toastr.info('Upload Successful.');
            this.init();
        };
        this.onUploadError = (response) => {
            this.toastr.error('Upload Error.');
            this.init();
        };
        this.onUploadProgress = (evt) => {
            let loaded = evt.loaded;
            let total = evt.total;
            // const progress: number = Math.min(
            //     100,
            //     parseInt('100.0 * ' + loaded + ' /  ' + total)
            // );
            if (loaded !== total) {
                this.toastr.info('Uploaded ' + loaded + ' of ' + total);
            }
            // this.state.uploadProgress = progress;
        };
        this.window = $window;
        this.browser = $browser;
        this.toastr = toastr;
        this.UserDetails = UserDetailsApi;
        this.Upload = Upload;
        this.TestCaseMedadataServiceApi = TestCaseMedadataServiceApi;
        this.TestCasesServiceApi = TestCasesServiceApi;
    }
    selectTest(test) {
        // reset the selected test data initially
        // This will disable the buttons until we have a response from the call below
        // that will re-populate the selectedTest and re-enable the buttons
        // This prevents a potential problem where we have enabled buttons but no test data.
        // It also sets some default info if we have no test to work with - test === null
        this.state.selectedTest = {
            Id: 0,
            TestCaseName: 'Not selected',
            TestCaseInformation: ''
        };
        this.data.testCaseMetadataUpdate = null;
        this.data.testCaseMetadataList = null;
        if (test !== null && test !== undefined) {
            this.TestCaseMedadataServiceApi.testCaseById(test.Id).then((response) => {
                // Patch the TestCaseInformation into the test
                this.data.testCaseMetadataUpdate = response.data;
                this.data.testCaseMetadataList =
                    response.data.TestCaseXmlKVPList;
                this.state.selectedTest = test;
                // angular.copy(test, this.data.editTest);
                this.state.showUpdated = false;
            });
        }
    }
}
angular.module('app').component('editTestCaseComponent', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ManageTestSuites/TestCases/edit-test-case.tpl.html',
    controllerAs: 'vm',
    controller: EditTestCaseController
});
